import P from 'prop-types';

import React from 'react';

export const LabelForm = ({ text = '', labelFor = '', className = '' }) => {
  return (
    <label htmlFor={labelFor} className={className}>
      {text}
    </label>
  );
};

LabelForm.propTypes = {
  text: P.string.isRequired,
  labelFor: P.string,
  className: P.string,
};
